<div class="footer">    
    <div class="page-layout container-footer" fxLayout="column" [ngClass.lt-lg]="'p-24'">
        <div class="footer-top" fxLayout="row" fxLayout.lt-lg="column" fxFlex="100" fxLayoutAlign="space-between">
            <div class="box-logo-redes" fxLayoutAlign.sm="space-between" fxLayoutAlign.md="space-between" fxLayout.xs="row">
                <div fxFlex.xs="50" class="logo-ase-gris">             
                    <img src="assets/images/logos/Logo_ase.svg" alt="ASE">                            
                </div>
                
                <div class="telefono-tablet" fxFlex.sm="30" fxLayoutGap="10px" fxLayout.sm="row" fxLayout.md="row" fxLayoutAlign="center" fxHide.xs fxShow.sm fxShow.md fxHide.gt-md>           
                    <div class="icon-telefono">          
                        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="21" cy="21" r="21" fill="#E65300"/>
                            <g clip-path="url(#clip0_945_15457)">
                            <path d="M15.54 14C15.6 14.89 15.75 15.76 15.99 16.59L14.79 17.79C14.38 16.59 14.12 15.32 14.03 14H15.54ZM25.4 26.02C26.25 26.26 27.12 26.41 28 26.47V27.96C26.68 27.87 25.41 27.61 24.2 27.21L25.4 26.02ZM16.5 12H13C12.45 12 12 12.45 12 13C12 22.39 19.61 30 29 30C29.55 30 30 29.55 30 29V25.51C30 24.96 29.55 24.51 29 24.51C27.76 24.51 26.55 24.31 25.43 23.94C25.33 23.9 25.22 23.89 25.12 23.89C24.86 23.89 24.61 23.99 24.41 24.18L22.21 26.38C19.38 24.93 17.06 22.62 15.62 19.79L17.82 17.59C18.1 17.31 18.18 16.92 18.07 16.57C17.7 15.45 17.5 14.25 17.5 13C17.5 12.45 17.05 12 16.5 12Z" fill="white"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_945_15457">
                            <rect width="24" height="24" fill="white" transform="translate(9 9)"/>
                            </clipPath>
                            </defs>
                        </svg>
                    </div>  
                    <div class="tenes-consultas">
                        <p class="frase">¿ Tenés consultas ?</p>
                        <p><a class="link-tel" href="tel:0810333273">0810 3333 273</a></p>
                        <p class="horario">Lunes a viernes de 9 a 17hs.</p>
                    </div>				
                </div>

                
            </div>	

            <div class="linea-vertical" fxHide.lt-lg fxShow.gt-md></div>
            <div class="linea" fxShow.xs fxHide.sm fxHide.md fxHide.gt-md fxFlexOrder.lt-lg="4"></div>
            <div class="telefono" fxFlex="22" fxFlex.xs="100" fxLayout="row" fxHide.sm fxHide.md fxFlexOrder.lt-lg="5" fxLayoutGap="15px">           
                <div class="icon-telefono">          
                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21" cy="21" r="21" fill="#E65300"/>
                        <g clip-path="url(#clip0_945_15457)">
                        <path d="M15.54 14C15.6 14.89 15.75 15.76 15.99 16.59L14.79 17.79C14.38 16.59 14.12 15.32 14.03 14H15.54ZM25.4 26.02C26.25 26.26 27.12 26.41 28 26.47V27.96C26.68 27.87 25.41 27.61 24.2 27.21L25.4 26.02ZM16.5 12H13C12.45 12 12 12.45 12 13C12 22.39 19.61 30 29 30C29.55 30 30 29.55 30 29V25.51C30 24.96 29.55 24.51 29 24.51C27.76 24.51 26.55 24.31 25.43 23.94C25.33 23.9 25.22 23.89 25.12 23.89C24.86 23.89 24.61 23.99 24.41 24.18L22.21 26.38C19.38 24.93 17.06 22.62 15.62 19.79L17.82 17.59C18.1 17.31 18.18 16.92 18.07 16.57C17.7 15.45 17.5 14.25 17.5 13C17.5 12.45 17.05 12 16.5 12Z" fill="white"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_945_15457">
                        <rect width="24" height="24" fill="white" transform="translate(9 9)"/>
                        </clipPath>
                        </defs>
                    </svg>
                </div>  
                <div class="tenes-consultas">
                    <p class="frase" fxHide.xs fxShow.gt.xs>¿ Tenés consultas ?</p>
                    <p class="frase" fxShow.xs fxHide.gt-xs>Teléfono de consultas</p>                    
                    <p><a class="link-tel" href="tel:0810333273">0810 3333 273</a></p>
                    <p class="horario">Lunes a viernes de 9 a 17hs.</p>
                </div>
            </div>
            <div class="linea" fxShow.xs fxHide.sm fxHide.md fxHide.gt-md fxFlexOrder.lt-lg="6"></div> 
            <div class="linea-vertical" fxHide.lt-lg></div>
            <div class="sitemap-secciones" fxFlex="20" fxFlex.xs="100" fxFlexOrder.xs="2" fxShow.xs fxHide.sm fxHide.md fxShow.gt-md>
                <ul>
                    <li><a href="/">Inicio</a></li>
                    <li><a href="/informacion-institucional">Información Institucional</a></li>
                    <li><a href="/contacto">Contacto</a></li>
                </ul>            
            </div>

            <div class="sitemap-portales" fxFlex="25" fxFlex.xs="100" fxFlexOrder.xs="3" fxShow.xs fxHide.sm fxHide.md fxShow.gt-md>
                <ul class="sitemap">                
                    <li><a target="_blank" href="https://portalproveedores.ase.com.ar/">Portal de Pagos Proveedores</a></li>
                    <li><a target="_blank" href="https://egtq.login.us2.oraclecloud.com/">Portal de Compras Proveedores</a></li>
                    <li><a target="_blank" href="https://egtq.fa.us2.oraclecloud.com/fscmUI/faces/PrcPosRegisterSupplier?prcBuId=300000002814052&lang=es">Registro Proveedores</a></li>
                    <li><a target="_blank" href="https://medife.hiringroom.com/jobs/microsite/ase">Sumate a Nuestro Equipo (RRHH)</a></li>
                    <li><a [routerLink]="[ '/monotributistas' ]">Portal del Monotributista</a></li>
                </ul>  
            </div>       
        </div>  

        <div class="menu-tablet" fxShow.sm fxShow.md fxHide.xs fxHide.gt-md fxLayout.sm="row" fxLayout.md="row" fxLayoutAlign-sm="end start" fxLayoutAlign="end start">						
			<div class="sitemap-secciones" fxFlex.sm="35" fxFlex.md="30">
				<ul>
					<li><a href="/">Inicio</a></li>
					<li><a href="/informacion-institucional">Información Institucional</a></li>
					<li><a href="/contacto">Contacto</a></li>
				</ul>            
			</div>
			<div class="sitemap-portales">
				<ul class="ul-sitemap">                
					<li><a target="_blank" href="https://portalproveedores.ase.com.ar/">Portal de Pagos Proveedores</a></li>
					<li><a target="_blank" href="https://egtq.login.us2.oraclecloud.com/">Portal de Compras Proveedores</a></li>
					<li><a target="_blank" href="https://egtq.fa.us2.oraclecloud.com/fscmUI/faces/PrcPosRegisterSupplier?prcBuId=300000002814052&lang=es">Registro Proveedores</a></li>
					<li><a target="_blank" href="https://medife.hiringroom.com/jobs/microsite/ase">Sumate a Nuestro Equipo (RRHH)</a></li>
					<li><a [routerLink]="[ '/monotributistas' ]">Portal del Monotributista</a></li>
				</ul>  
			</div> 		
		</div>

        <div class="linea" fxHide.xs fxShow.gt-sm></div>
        <div class="footer-bottom" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between" fxFlex="100" fxLayoutGap="20px">

            <div class="ssl" fxFlex="80" fxFlex.sm="80" fxFlex.md="80">
                <p>Superintendencia de Servicios de Salud - Órgano de Control de Obras Sociales y Entidades de Medicinas Prepagas 0800 222 SALUD (72583)</p>
                <p><a href="http://www.sssalud.gob.ar" target="blank">www.sssalud.gob.ar</a> - R.N.O.S. 400909</p>
                <p><a>Política de Privacidad</a></p>
                <p><a (click)="openPopup()">Resolución 274/2021 – Ventanilla Única Federal</a></p>
            </div>

            <div class="box-logos-bd-df" fxFlex="20" fxFlex.sm="20" fxFlex.md="20" fxLayout="row" fxLayoutAlign="end" fxLayoutAlign.xs="start" fxLayoutGap="10px" fxLayoutGap.lt-lg="20px">
                <div class="basedatos">
                    <a href="https://www.argentina.gob.ar/aaip/datospersonales/reclama/30578079994--RL-2021-99091013-APN-DNPDP#AAIP" target="_blank"> 
                        <img src="assets/images/logos/logo_aiap.jpg" alt="AIAP">
                    </a>                
                </div>
                <div class="datafiscal">
                        <a href="https://servicios1.afip.gov.ar/clavefiscal/qr/response.aspx?qr=McKo11WX0LkYR5FveuznJg,," target="_F960AFIPInfo">                            
                            <img src="assets/images/logos/logo_datafiscal.jpg" alt="Data Fiscal">
                        </a>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="footer-copyright">
    <div class="copyright" fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
        <p>© {{ year }} ASE Nacional. Todos los derechos reservados.</p>
    </div>   
</div>

<mat-toolbar fxHide>
</mat-toolbar>
